import * as React from 'react';
import {CSSProperties} from 'react';
import {GetFieldDecoratorOptions, ValidationRule, WrappedFormUtils} from 'antd/lib/form/Form';
import FormItem from 'antd/lib/form/FormItem';
import locales from '../../locales';


export interface BaseFormItemProps {
  form: WrappedFormUtils;
  fieldId: string;
  label?: React.ReactNode;
  initialValue: any;
  required: boolean;
  disabled?: boolean;
  rules?: ValidationRule[];
  valuePropName?: string;
  style?: CSSProperties;
  className?: string;
}

interface BaseFormItemPropsWithInput extends BaseFormItemProps {
  input: React.ReactNode;
}

class VerticalBaseFormItem extends React.Component<BaseFormItemPropsWithInput, {}> {

  public render(): React.ReactNode {
    const {
      form,
      input,
      fieldId,
      label,
      initialValue,
      required,
      rules,
      valuePropName,
      style,
      className,
    } = this.props;

    const rulez: ValidationRule[] = [
      // Required rule
      ...required ? [{required: true, message: locales.mandatory}] : [],
      // Optional rules props
      ...rules ? rules : [],
    ];

    const options: GetFieldDecoratorOptions = {
      initialValue,
      rules: rulez,
    };
    // If valuePropName is set but undefined on options, rc-form will crash!
    if (valuePropName) {
      options.valuePropName = valuePropName;
    }

    return (
      <FormItem className={className} label={label} style={style} >
        {form.getFieldDecorator(fieldId, options)(input)}
        {this.props.children}
      </FormItem>
    );
  }
}

export default VerticalBaseFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/VerticalBaseFormItem.tsx